import { Injectable } from '@angular/core';
import {FlamingoHttpService} from '../../../@flamingo/service/flamingo-http.service';

export enum RemoteFileType {
  COMPANY_IMPORT_XLS_TEMPLATE = 'CompanyImportPartner',
}

@Injectable({
  providedIn: 'root'
})
export class RemoteFileRepositoryService {

  constructor(
    private _httpService: FlamingoHttpService,
  ) { }

  public downloadFile(type: RemoteFileType): void {
    this._httpService.getUrl(`/partner/files/${type}`).subscribe(res => {
      window.open(res);
    });
  }
}
